import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import AICallSummaryModel from "../../models/ai-call-summary";

export default class AICallSummaryRepository extends BaseRepository {
  static modelClass = AICallSummaryModel;
  modelName = "ai-call-summary";
}
